function initExternalLinkNotice() {
  const notice = document.querySelector(".external-link-notice");
  if (!notice) return;

  let pendingUrl = null;
  let pendingVariant = "external";

  const stripWww = (host) => host.replace(/^www\./, "");

  // Decide whether a link should be intercepted and, if so, which wording to show.
  // Returns { url, variant } to intercept, or null to let the click proceed.
  function classify(anchor) {
    // Opt-out: the attribute on the anchor itself (PHP templates), or either marker on an
    // ancestor. core/button puts "Additional CSS class(es)" on the .wp-block-button wrapper,
    // so the class has to be matched from above the anchor.
    if (anchor.closest("[data-no-external-notice], .no-external-notice")) return null;
    if (notice.contains(anchor)) return null;

    const href = anchor.getAttribute("href");
    if (!href || href.startsWith("#") || href.startsWith("javascript:")) return null;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (e) {
      return null;
    }

    if (url.protocol === "mailto:") return { url: url.href, variant: "email" };
    if (url.protocol === "tel:") return null;

    if (url.protocol === "http:" || url.protocol === "https:") {
      if (stripWww(url.hostname) !== stripWww(window.location.hostname)) {
        return { url: url.href, variant: "external" };
      }
    }
    return null;
  }

  document.addEventListener("click", (e) => {
    // ignore modified clicks so users can still force-open in a new tab, etc.
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const anchor = e.target.closest("a[href]");
    if (!anchor) return;

    const match = classify(anchor);
    if (!match) return;

    e.preventDefault();
    pendingUrl = match.url;
    pendingVariant = match.variant;
    notice.setAttribute("data-variant", match.variant);
    notice.showModal();
  });

  notice.querySelector(".external-link-notice-confirm")?.addEventListener("click", () => {
    if (pendingUrl) {
      if (pendingVariant === "external") {
        window.open(pendingUrl, "_blank", "noopener,noreferrer");
      } else {
        window.location.href = pendingUrl;
      }
    }
    notice.close();
  });

  notice.querySelector(".external-link-notice-cancel")?.addEventListener("click", () => notice.close());
  notice.querySelector(".external-link-notice-close")?.addEventListener("click", () => notice.close());

  // light-dismiss when clicking the backdrop
  notice.addEventListener("click", (e) => {
    if (e.target === notice) notice.close();
  });

  // clear the pending target on any close (button, Esc, or backdrop)
  notice.addEventListener("close", () => {
    pendingUrl = null;
  });
}

// theme.js is a footer script that can execute before the dialog markup
// (hooked later in wp_footer) is parsed, so wait for the DOM to be ready.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initExternalLinkNotice);
} else {
  initExternalLinkNotice();
}
